(function () {
    'use strict';

    angular
        .module('core.services')
        .service('RegionalService', RegionalService)

    /** @ngInject */
    function RegionalService(HttpService) {
        const RegionalService = {
            get,
            getAll,
            getByParameters,
            post,
            put,
            migrateData,
            deleteData
        }

        return RegionalService;

        function get(regionalId) {
            return HttpService.get(`/regionals/${regionalId}`);
        }

        function getAll() {
            return HttpService.get('/regionals/by-parameters');
        }

        function getByParameters(params) {
            return HttpService.get('/regionals/by-parameters', {
                params
            });
        }

        function post(regionalData) {
            return HttpService.post('/regionals', regionalData);
        }

        function put(regionalData) {
            return HttpService.put('/regionals', regionalData);
        }

        function migrateData(regionalOriginId, regionalDestinationId) {
            return HttpService.put(`/regionals/migrate/${regionalOriginId}/${regionalDestinationId}`);
        }

        function deleteData(regionalId) {
            return HttpService.delete(`/regionals/${regionalId}`);
        }
    }
}());